import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { business, navigation } from '../config/siteData';

export function Logo({ light = false }) {
  return (
    <a
      className={`brand ${light ? 'brand-light' : ''}`}
      href="#home"
      aria-label="The Cleaning Bees home"
    >
      <img
        src={business.logo}
        alt="The Cleaning Bees Turnaround Experts logo"
      />
    </a>
  );
}

export function Header() {
  const [open, setOpen] = useState(false);

  const closeMenu = () => setOpen(false);

  return (
    <header className="site-header">
      <div className="nav-shell">
        <Logo />
        <nav
          className={open ? 'nav-links nav-open' : 'nav-links'}
          aria-label="Primary navigation"
        >
          {navigation.map(([label, id]) => (
            <a key={id} href={`#${id}`} onClick={closeMenu}>
              {label}
            </a>
          ))}
          <a
            className="button button-small mobile-quote"
            href="#quote"
            onClick={closeMenu}
          >
            Request a Quote
          </a>
        </nav>
        <a className="button button-small desktop-quote" href="#quote">
          Request a Quote
        </a>
        <button
          className="menu-button"
          type="button"
          aria-label="Toggle navigation"
          aria-expanded={open}
          onClick={() => setOpen((current) => !current)}
        >
          <SafeIcon icon={open ? FiIcons.FiX : FiIcons.FiMenu} />
        </button>
      </div>
    </header>
  );
}